var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn basic-heading"},[_c('div',{staticClass:"clearfix"},[_c('span',{class:_vm.headerSize},[_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]})],2),_c('span',{staticClass:"float-right"},[_vm._t("right-content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }